import client from './apiClient.js';

let currentSessionPromise = null;

/**
 * Make sure that there's a current signup session
 * @param {Object} p params
 * @param {string} p.entrypoint entrypoint
 * @param {string} p.market market
 * @param {string} p.language language
 * @param {string} p.signupType signup type
 * @return {Promise} promise which resolves when a session has been created
 */
export default async function ensureSignupSession({entrypoint, market, language, signupType}) {
    /* istanbul ignore if */
    if (currentSessionPromise) {
        return currentSessionPromise;
    }
    if (client.currentSessionId) {
        return;
    }
    currentSessionPromise = client.createSession({
        entrypoint,
        market,
        language,
        signupType,
        referrer: document.referrer
    }).then((sessionId) => {
        currentSessionPromise = null;
        return sessionId;
    }, (err) => {
        currentSessionPromise = null;
        console.error(`Error creating signup session: `, err);
    });
    await currentSessionPromise;
}
